import React, { type JSX } from "react";
import type { ConversationFilters, PaginationInfo } from "../types";
import type { FilterValue } from "./useConversationList";

/** Result count, page size and any API error. */
export default function ConversationsSummaryBar({
  pagination,
  error,
  pageSize,
  hidingZeroTurn,
  hidingCoreTeam,
  onFilterChange,
}: {
  pagination: PaginationInfo | null;
  error: string | null;
  pageSize: number;
  hidingZeroTurn: boolean;
  hidingCoreTeam: boolean;
  onFilterChange: (field: keyof ConversationFilters, value: FilterValue) => void;
}): JSX.Element {
  return (
    <div className="flex items-center justify-between flex-wrap gap-4">
      <div className="flex items-baseline gap-2 flex-wrap">
        <h2 className="text-xl font-semibold text-gray-900">
          Conversations {pagination && `(${pagination.total_items})`}
        </h2>
        {/* The count reflects the filter, so say so rather than let it read as a total. */}
        {hidingZeroTurn && <span className="text-sm text-gray-500">0-turn sessions hidden</span>}
        {/* Core-team rows are dropped after the fetch, so the total counts them. */}
        {hidingCoreTeam && (
          <span className="text-sm text-gray-500">team members hidden (total still counts them)</span>
        )}
      </div>
      <div className="flex items-center space-x-4">
        {pagination && (
          <div className="flex items-center space-x-2">
            <label className="text-sm text-gray-700">Show:</label>
            <select
              value={pageSize}
              onChange={(e) => onFilterChange("page_size", parseInt(e.target.value))}
              className="px-2 py-1 border border-gray-300 rounded text-sm focus:ring-blue-500 focus:border-blue-500"
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <span className="text-sm text-gray-700">per page</span>
          </div>
        )}
        {error && (
          <div className="text-sm text-red-600 bg-red-50 px-3 py-1 rounded-md">
            API Error: {error}
          </div>
        )}
      </div>
    </div>
  );
}
